import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { tokenConfig } from "@/helpers/auth";
import carts from "./Carts";
import products from "./Products";
import orders from "./Orders";
import sales from "./Sales";
import staff from "./Staff";
import branches from "./Branches";
import vendors from "./Vendors";
import activity from "./Activity";
import analyses from "./Analyses";
import contacts from "./Contacts";

import router from "../router/index";

import { token } from "../helpers/auth";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: token,
    user: null,
    isAuthenticated: null,
    isLoading: false,

    branchVendor: null,
    onVendor: null,
    onBranch: null,

    snackbar: false,
    snackbarColor: "",
    snackbarMessage: "",
  },

  getters: {
    links: (state) => {
      if (state.isAuthenticated && state.user.user_type === "Staff") {
        var links = [
          {
            text: "Products",
            route: {
              name: "products",
              params: { branchId: state.user.native_branch },
            },
          },
          {
            text: "Orders",
            route: {
              name: "orders",
              params: { branchId: state.user.native_branch },
            },
          },
          {
            text: "Sales",
            route: {
              name: "sales",
              params: { branchId: state.user.native_branch },
            },
          },

          {
            text: "Activity",
            route: {
              name: "activity",
              params: { branchId: state.user.native_branch },
            },
          },
          { text: "Account", route: { name: "edit_account" } },
        ];

        if (state.user.is_privileged) {
          links.push(
            {
              text: "Analyses",
              route: {
                name: "analyses",
                params: { branchId: state.user.native_branch },
              },
            },
            {
              text: "Contacts",
              route: {
                name: "contacts",
                params: { branchId: state.user.native_branch },
              },
            }
          );
        }

        return links;
      } else if (state.isAuthenticated && state.user.user_type === "Vendor")
        return [
          {
            text: "Branches",
            route: {
              name: "branches",
              params: { username: state.user.native_vendor },
            },
          },
          { text: "Account", route: { name: "edit_account" } },
        ];
    },

    userDetails(state) {
      return {
        id: state.user.id,
        name: state.user.name,
        username: state.user.username,
        email: state.user.email,
      };
    },

    isAuthorized(state) {
      if (state.isAuthenticated) {
        if (state.user.user_type === "Vendor") {
          if (state.user.native_vendor === state.branchVendor) {
            return true;
          } else return false;
        } else if (state.user.user_type === "Staff") {
          //   if (state.user.native_branch === this.$route.params.branchId) {
          //     return true;
          //   } else return false;
          // } else {
          //   return false;
          return false;
        } else return false;
      } else {
        return false;
      }
    },

    isAuthorized2(state) {
      if (state.isAuthenticated) {
        if (state.user.user_type === "Vendor") {
          if (state.user.native_vendor === state.branchVendor) {
            return true;
          } else return false;
        } else if (state.user.user_type === "Staff") {
          if (state.user.native_branch === state.onBranch) {
            return true;
          } else return false;
        } else return false;
      } else {
        return false;
      }
    },

    isAuthorizedVendor(state) {
      if (state.isAuthenticated) {
        if (state.user.user_type === "Vendor") {
          if (state.user.native_vendor === state.onVendor) {
            return true;
          } else return false;
        } else return false;
      } else {
        return false;
      }
    },
  },
  mutations: {
    updateUser(state, payload) {
      state.user = Object.assign({}, payload);
    },

    setBranchVendor(state, payload = null) {
      state.branchVendor = payload;
    },

    setOnVendor(state, payload = null) {
      state.onVendor = payload;
    },

    setOnBranch(state, payload = null) {
      state.onBranch = payload;
    },

    handleResponse(state, response) {
      //Set Snackbar
      state.snackbar = true;
      state.snackbarColor = response.color;
      state.snackbarMessage = response.msg;
    },

    setSnackbar(state, payload) {
      state.snackbar = payload.state;
      state.snackbarColor = payload.color;
      state.snackbarMessage = payload.comment;
    },

    userLoading(state) {
      state.isLoading = true;
    },

    userLoaded(state, payload) {
      state.isAuthenticated = true;
      state.isLoading = false;
      state.user = payload;
    },

    unauthenticated(state) {
      document.cookie =
        "TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      state.isLoading = false;
    },

    registerSuccess(state, payload) {
      localStorage.setItem("token", payload.token);
      state.token = payload.token;
      state.user = payload.user;
      state.isAuthenticated = true;
      state.isLoading = false;
    },

    loginSuccess(state, payload) {
      localStorage.setItem("token", payload.token);
      state.token = payload.token;
      state.user = payload.user;
      state.isAuthenticated = true;
      state.isLoading = false;
    },
  },
  actions: {
    loadUser({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit("userLoading");

        axios
          .get("/api/v1/users/user/get_current_user/", tokenConfig(state))
          .then((response) => {
            commit("userLoaded", response.data);

            resolve(response);
          })
          .catch((error) => {
            commit("unauthenticated");

            reject(error);
          });
      });
    },

    sendResetCode({ dispatch, state, commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `/api/v1/users/user/send_verification_code/`,
            data,
            tokenConfig(state)
          )
          .then((response) => {
            resolve(response);

            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Verification code was sent",
            });
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    verifyResetCode({ dispatch, state }, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/users/user/verify_code/`, data, tokenConfig(state))
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    resetPassword({ dispatch, state, commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/users/user/reset_password/`, data, tokenConfig(state))
          .then((response) => {
            commit("unauthenticated");
            resolve(response);

            commit("setSnackbar", {
              state: true,
              color: "success",
              comment: "Password was reset",
            });
          })
          .catch((error) => {
            dispatch("handleError", error);
            reject(error);
          });
      });
    },

    handleError({ commit }, error) {
      var msg;
      if (error.response) {
        var response = error.response;
        var status = response.status;

        if (status === 403) {
          if (response.data && response.data.detail) msg = response.data.detail;
          else msg = "You are restricted";
        } else if (status === 400 || status === 401) {
          if (response.data && response.data.message)
            msg = response.data.message;
          else if (response.data) msg = response.data;
          else msg = "Something went wrong";

          if (status === 401) {
            commit("unauthenticated");
            router.push({ name: "login" });
          }
        } else if (response.status === 500) {
          msg = "An error occurred. Try again";
        } else if (response.status === 404) {
          msg = "Not Found";
        } else {
          msg = "An error occurred";
        }
      } else {
        msg = "Check connection and try again";
      }

      //Set Snackbar
      commit("setSnackbar", {
        state: true,
        color: "error",
        comment: msg,
      });
    },
  },
  modules: {
    carts,
    products,
    orders,
    sales,
    staff,
    branches,
    vendors,
    activity,
    analyses,
    contacts,
  },
});
